import { FC, useRef, useState } from 'react'
import {
  DialogActionTrigger,
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
  DialogTrigger,
} from '../chakraComponents/dialog'
import {
  Button,
  createListCollection,
  DialogOpenChangeDetails,
} from '@chakra-ui/react'
import { Tab } from './EditorTabs'
import { ImplementationSelector } from './ImplementationSelector'
import { ImplementationWithCompanyName } from '../../models/ImplementationWithCompanyName'

interface AddEventTemplateDialogProps {
  addEventTemplate: (implementationId: string) => void
  implementations: ImplementationWithCompanyName[]
}

export const AddEventTemplateDialog: FC<AddEventTemplateDialogProps> = ({
  addEventTemplate,
  implementations,
}) => {
  const contentRef = useRef<HTMLDivElement>(null)

  const [selectedImplementationId, setSelectedImplementationId] =
    useState<string>()

  const implementationsCollection = createListCollection({
    items: implementations.map((i) => ({
      label: `${i.companyName} - ${i.implementationName}`,
      value: i.implementationId,
    })),
  })

  const handleOnOpenChange = ({ open }: DialogOpenChangeDetails) => {
    if (open) {
      setSelectedImplementationId(undefined)
    }
  }

  const handleCreate = () => {
    if (selectedImplementationId) {
      addEventTemplate(selectedImplementationId)
    }
  }

  return (
    <DialogRoot onOpenChange={handleOnOpenChange}>
      <DialogTrigger asChild>
        <Tab tabName={'+'} />
      </DialogTrigger>
      <DialogContent ref={contentRef}>
        <DialogHeader>
          <DialogTitle>Create event template</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <ImplementationSelector
            ref={contentRef}
            implementationsCollection={implementationsCollection}
            setSelectedImplementationId={setSelectedImplementationId}
          />
        </DialogBody>
        <DialogFooter>
          <DialogActionTrigger asChild>
            <Button variant='outline'>Cancel</Button>
          </DialogActionTrigger>
          <DialogActionTrigger>
            <Button
              backgroundColor={'primary.4'}
              onClick={handleCreate}
              disabled={!selectedImplementationId}>
              Create
            </Button>
          </DialogActionTrigger>
        </DialogFooter>
        <DialogCloseTrigger />
      </DialogContent>
    </DialogRoot>
  )
}
